import React, { useState } from 'react';
import styled from 'styled-components'

import { LinksArray } from './Links'
import { links } from '../../Router'
import Icon from '../reusable/Icon'


const MobileNavigation = (props) => {
  const [open, toggleOpen] = useState(false);

  const close = () => {
    toggleOpen(false)
    return "Closed"
  }
  
  return(
    <React.Fragment>
      <HaburgerWrapper onClick={()=>toggleOpen(!open)}>
        <Icon margin="0px 0px 0px 0px" width={24} icon="hamburger" />
      </HaburgerWrapper>
      <NavigationWrapper open={open}>
        <Navigation open={open}>
          <BackgroundImg src="mobileSculpture1.png" alt="" />
          <CloseNav onClick={close} >
            <Icon margin="0px 0px 0px 0px" width={24} height={24} icon="close" />
          </CloseNav>
          <LinkWrapper>
            <LinksArray toggleOpen={toggleOpen} onClick={close} links={links.slice(0,links.length)} />
          </LinkWrapper>
        </Navigation>
      </NavigationWrapper>
    </React.Fragment>
  )
}

export default MobileNavigation



const BackgroundImg = styled.img(props => ({
  position:"absolute",
  top:100,
  right:"80%",
  height:355,
}));

const LinkWrapper = styled.div(props => ({
  width:"calc(100% - 40px)",
  position:"relative",
  padding:20,
  paddingTop:24,
  "@media (max-width: 650px)": {
    display:"flex",
    alignItems:"center",
    flexDirection:"column",
  }
}));

const HaburgerWrapper = styled.div(props => ({
  width:24,
  height:24,
  "@media (min-width: 651px)": {
    display:"none",
  },
}));

const NavigationWrapper = styled.div(props => ({
  display:"none",
  "@media (max-width: 650px)": {
    position:"fixed",
    top:0,
    left:0,
    bottom:0,
    right:0,
    zIndex:10,
    background:"rgba(0,0,0,0.5)",
    display:"flex",
    transition:"0.2s visibility 0s, 0.2s opacity 0.2s",
    visibility: props.open ? "visible":"hidden",
    opacity: props.open ? 1:0,
  },
}));

const CloseNav = styled.div(props => ({
  display:"felx",
  justifyContent:"flex-end",
  marginTop:44,
  marginRight:16,
}));

const Navigation = styled.div(props => ({
  position:"absolute",
  left: props.open ? 0:-650,
  transition:"0.2s ease-in-out 0.2s",
  background:"#fff",
  width:"100vw",
  overflowX:"auto",
  height:"100%",
  boxShadow: "0px 8px 40px rgba(0, 0, 0, 0.03)",
}));
